module.exports = __webpack_public_path__ + "static/page-layer-bg1-628752aff3d765e1ff6d57deef227907.jpg";